/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { use } from 'fierry/react';

import Time from 'solis/time';

import { formatDuration, formatCompactDuration } from 'solis/claude/util/duration';


export default ({ date, compact }) =>
{
  const now = use(Time);

  return compact ? formatCompactDuration(date - now) : formatDuration(date - now);
};
